import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";

/**
 * Root route. Mounts once for the whole app; every other route
 * renders inside its `<Outlet />`. The Next-side `(app)/layout.tsx`
 * does sidebar + auth gate + live-refresh, etc. — those will land
 * in this tree as nested routes in subsequent phases (auth on the
 * root, layout under an `_app` pathless route below the auth gate).
 *
 * `createRootRouteWithContext` lets every route loader/action see
 * the `queryClient` without having to import it directly — keeps
 * routes loosely coupled to the QueryClient instance.
 */
export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootComponent,
});

function RootComponent() {
  return <Outlet />;
}
